import { render } from "./LbrxStepSidebar.vue?vue&type=template&id=abb9f422"
import script from "./LbrxStepSidebar.vue?vue&type=script&lang=js"
export * from "./LbrxStepSidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__